import { render } from "./AsideECP.vue?vue&type=template&id=8cae2742&ts=true"
import script from "./AsideECP.vue?vue&type=script&lang=ts"
export * from "./AsideECP.vue?vue&type=script&lang=ts"

import "./AsideECP.vue?vue&type=style&index=0&id=8cae2742&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__